import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const InternalVsExternalSupport5 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="internalVsExternalSupport" section="comparison">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="internalVsExternalSupport:comparison" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default InternalVsExternalSupport5;
